function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 41 32"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15.22 0l-5.3 5.29H4.65A2.64 2.64 0 002 7.93v18.5a2.64 2.64 0 002.64 2.64h7.93v-2.64H4.65V7.93h6.38l5.28-5.29h8.39l5.28 5.29h6.38v18.5h-7.93v2.64h7.93A2.64 2.64 0 0039 26.43V7.93a2.64 2.64 0 00-2.64-2.64h-5.29L25.8 0H15.22z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.08 18.5a10.57 10.57 0 10-21.14 0 10.57 10.57 0 0021.14 0zm-18.5 0a7.93 7.93 0 1115.86 0 7.93 7.93 0 01-15.86 0z"
}), /*#__PURE__*/React.createElement("rect", {
  width: "5.29",
  height: "2.64",
  x: "4.65",
  rx: ".5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.79 18.5a5.29 5.29 0 00-5.29-5.28h-.06.06v2.64a2.64 2.64 0 012.65 2.64h2.64zm-10.57.16v-.32a5.57 5.57 0 000 .32z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 29.65L39.55 4l1.36 2.1L1.36 31.75 0 29.65z"
})));